<template>
  <div class="space-y-10 lg:space-y-16">
    <vf-carousel-elevate
      v-if="productFeatures && showProductFeatures"
      v-style:mx="{ sm: '-1rem', lg: '-5.5rem' }"
      align="start"
      class="group"
      class-controls="mx-6 b b-white rounded-full bg-white/75 flex h-11 w-11 shadow-sm center backdrop-blur <lg:hidden"
      loop
      show-arrows-on-hover-only
      size-controls="md"
      :slides-to-scroll="1"
    >
      <button
        v-for="({ bgImageURL, label, thumbnail }, i) in productFeatures.data"
        :key="i"
        v-style:w="{ sm: '64%', lg: productFeatures.data.length > 3 ? '30%' : 'calc(100% / 3)' }"
        class="relative c-white"
        :style="{
          'aspect-ratio': '7 / 9',
          'background-image': `url(${getImageTransformations(bgImageURL, { excludeDPR: true,
                                                                           quality: 'auto',
                                                                           width: 768,
                                                                           sharpen: 0 })})`,
          'background-size': 'cover',
          'background-position': 'center',
        }"
        @click="PanelProductDetailCard.open({
          data: productFeatures.data,
          title: productFeatures.label || $t.features,
        })"
      >
        <span class="absolute-0" style="background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.2))" />
        <vf-icon
          v-if="thumbnail"
          class="absolute left-1/2 top-1/2 -translate-1/2"
          :height="{ sm: '40', lg: '60' }"
          :src="thumbnail"
          :width="{ sm: '40', lg: '60' }"
        />
        <span v-if="label" class="body-4 absolute bottom-0 left-0 m-4 underlined lg:m-6">
          {{ label }}
        </span>
      </button>
    </vf-carousel-elevate>
    <div :class="{ 'lg:pt-16': !(productFeatures && showProductFeatures) }">
      <vf-accordion
        v-for="({
          data,
          id,
          label,
          layout = 'grid',
          expanded,
        }, i) in showProductFeatures ? productDetails.filter(({ id }) => id !== 'productFeatures') : productDetails"
        :key="i"
        :id
        :open="$feature.allowOpenedDetailsAccordionsOnPDP && expanded"
        :title="label"
        variant="aligned"
      >
        <div class="body-3 pb-4 pt-2">
          <component
            :is="componentTypes[DETAIL_LAYOUTS.includes(layout) ? layout : 'detailCard']"
            :data
            :title="label"
          />
        </div>
      </vf-accordion>
    </div>
    <panel-product-detail-card size="lg" />
  </div>
</template>

<script setup lang="ts">
import type { ProductDetails } from '#root/api/clients/product/data-contracts'
import {
  LazyProductAccordionsBulletin,
  LazyProductAccordionsDetailCard,
  LazyProductAccordionsGrid,
  LazyProductAccordionsKeyValue,
  LazyProductAccordionsScale
} from '#components'
import { DETAIL_LAYOUTS } from '#types/product'

const props = defineProps<{
  productDetails: ProductDetails[]
  heading?: string
  description?: string
}>()

const componentTypes = {
  bulletin: LazyProductAccordionsBulletin,
  detailCard: LazyProductAccordionsDetailCard,
  grid: LazyProductAccordionsGrid,
  keyValue: LazyProductAccordionsKeyValue,
  modalGrid: LazyProductAccordionsDetailCard,
  scale: LazyProductAccordionsScale
}

const { $viewport } = useNuxtApp()

const productFeatures = computed(() => props.productDetails.find(({ id }) => id === 'productFeatures'))
const showProductFeatures = computed(() => productFeatures.value
  && productFeatures.value.data.length > ($viewport.breakpoint === 'lg' ? 2 : 1)
  && productFeatures.value.data.some(({ bgImageURL }) => !!bgImageURL)
)

const PanelProductDetailCard = createPanel('product-detail-card')
</script>
